export default class InvalidCodeError<Data = unknown> extends Error {
  name = 'InvalidCodeError';

  constructor(readonly message = 'Invalid Code', readonly data?: Data) {
    super(message);
  }
}
